import { __decorate } from "tslib";
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { PsHttpService } from '@patsnap/tahiti-core/common/ps-http';
import { WORKSPACE_SERVICE_URI } from '@cores/constants/envConfig';
let OperationRecordsApiImpl = class OperationRecordsApiImpl extends PsHttpService {
    get options() {
        return {
            baseURL: `${WORKSPACE_SERVICE_URI}/workspace/web`,
            headers: {
                'X-API-Version': '2.0',
            },
        };
    }
    async getOperationRecords(params) {
        const res = await this.post({
            url: '/operation-record/list',
            data: params,
        });
        return res.data;
    }
    async getSpecialQueryOriginalText(params) {
        const res = await this.get({
            url: '/search/origin-query',
            params,
        });
        return res.data;
    }
};
OperationRecordsApiImpl = __decorate([
    injectable()
], OperationRecordsApiImpl);
export { OperationRecordsApiImpl };
